import type {
  AdminDashboardFilters,
  ErrorsResponse,
  LimitsStatus,
  TopConsumersResponse,
  UsageSummary,
  UsageTimeseries,
} from "@cdt/shared";
import { api } from "./api";

function buildQuery(filters: AdminDashboardFilters & Record<string, unknown>): string {
  const params = new URLSearchParams();
  for (const [key, value] of Object.entries(filters)) {
    if (value !== undefined && value !== null && value !== "") {
      params.set(key, String(value));
    }
  }
  const qs = params.toString();
  return qs ? `?${qs}` : "";
}

export async function fetchAdminSummary(
  filters: AdminDashboardFilters & { days?: number },
): Promise<UsageSummary> {
  return api.get<UsageSummary>(`/api/admin/summary${buildQuery(filters)}`);
}

export async function fetchAdminTimeseries(
  filters: AdminDashboardFilters & { days?: number },
): Promise<UsageTimeseries> {
  return api.get<UsageTimeseries>(`/api/admin/timeseries${buildQuery(filters)}`);
}

export async function fetchAdminTopConsumers(
  filters: AdminDashboardFilters & { days?: number; limit?: number },
): Promise<TopConsumersResponse> {
  return api.get<TopConsumersResponse>(`/api/admin/top${buildQuery(filters)}`);
}

export async function fetchAdminErrors(
  filters: AdminDashboardFilters & { days?: number; page?: number; pageSize?: number },
): Promise<ErrorsResponse> {
  return api.get<ErrorsResponse>(`/api/admin/errors${buildQuery(filters)}`);
}

export async function fetchAdminLimits(): Promise<LimitsStatus> {
  return api.get<LimitsStatus>("/api/admin/limits");
}
